<template>
  <div>
    <div class="jumbotron">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item active">Support Roster</li>
      </ol>
    </div>

    <div class="row">
      <div class="col">
        <blockquote class="blockquote">
          <form>
            <fieldset>
              <legend>Support Roster</legend>
              <div class="form-group">
                <div class="input-group">
                  <label class="col-4 col-form-label">Project</label>
                  <select
                    v-model="selectedProject"
                          class="custom-select form-control">
                      <option disabled value="">Please select one</option>
                      <option v-for="entry in projects">
                          {{ entry }}
                      </option>
                  </select>
                </div>
              </div>
            </fieldset>
          </form>
        </blockquote>
      </div>
      <div class="col">
        <div id="schema-access-info" class="alert alert-info pull-right" role="alert">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <strong>On Call Support Roster</strong><br>
          <p>Each project has a team support the project. The roster is used for deciding the recipient of outbound monitoring notifications</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
      <vue-good-table
          title="Team members"
          :columns="columns"
          :rows="rows"
          :search-options="{ enabled: true }"
          :paginationOptions="{ enabled: true }"
          styleClass="vgt-table striped bordered table-hover"
          :lineNumbers="true">
        <div slot="emptystate">
          Select a Project to view team members
        </div>
      </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        projects: [],
        selectedProject: null,
        loading: false,
        columns: [
          {
            label: 'Name',
            field: 'name',
            filterable: true
          },
          {
            label: 'Number',
            field: 'number',
            filterable: true
          },
          {
            label: 'Date',
            field: 'date',
            filterable: true
          }
        ],
        rows: [
        ]
      }
    },
    methods: {
      getProjects: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/support-roster/teams'
        vm.$parent.loading = true
        vm.axios.get(endpoint)
          .then(function (response) {
            // console.log(response)
            vm.$parent.loading = false
            vm.projects = response.data
          })
          .catch(function (error) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response, type: 'error' })
            console.log(error)
          })
      },
      getRoster: function (team) {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/support-roster/roster'
        var config = {}
        config['team'] = team

        var d = new Date()

        config['startDate'] = d.getFullYear() + '-01-01'
        config['endDate'] = (d.getFullYear() + 1) + '-01-01'
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.rows = response.data
            vm.$parent.loading = false
          })
          .catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response, type: 'error' })
          })
      }
    },
    created () {
      this.getProjects()
    },
    watch: {
      'selectedProject': function (val, oldVal) {
        if (val) {
          this.getRoster(val)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SupportRoster.vue?1f1a241c